"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultUtils = exports.ConfigUtils = void 0;
Object.defineProperty(exports, "simulateAsyncFetch", {
  enumerable: true,
  get: function get() {
    return _autocomplete.simulateAsyncFetch;
  }
});
Object.defineProperty(exports, "uuid", {
  enumerable: true,
  get: function get() {
    return _uuid["default"];
  }
});
Object.defineProperty(exports, "validateTree", {
  enumerable: true,
  get: function get() {
    return _validation.validateTree;
  }
});

var _validation = require("./validation");

var _autocomplete = require("./autocomplete");

var _uuid = _interopRequireDefault(require("./uuid"));

var _ConfigUtils = _interopRequireWildcard(require("./configUtils"));

exports.ConfigUtils = _ConfigUtils;

var _DefaultUtils = _interopRequireWildcard(require("./defaultUtils"));

exports.DefaultUtils = _DefaultUtils;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }